import React from "react";
import PageTitle from "../../../layout/PageTitle";
import {useMutation, useQuery} from "@apollo/client";
import {AddButton, DeleteButton, EditButton} from "../../../helpers/ButtonHelper";
import ListTable from "../../shared/ListTable";
import {deletePlateMutation, getPlates} from "./PlateQueries";
import {deleteItem, tableImageTag} from "../../../helpers/Api";
import {Link} from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const PlatesList = () => {
  const {data} = useQuery(getPlates, {fetchPolicy: "no-cache"})
  const [deleteCall] = useMutation(deletePlateMutation, {refetchQueries: [getPlates]})

  const header = <tr>
    <th>Denumire</th>
    {/*<th>Perioada zilei</th>*/}
    <th>#Ingrediente</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/plates/${item.id}`}>
          {tableImageTag(item)}
          {item.name}
        </Link>
      </td>
      {/*<td>{item.category.name}</td>*/}
      <td>
        {item.ingredientsCount}
        {String(item.ingredientsCount) === '0' &&
          <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltips">Lipsesc ingredientele!</Tooltip>}>
            <Badge pill bg="danger" className="px-2 ms-2 color">!</Badge>
          </OverlayTrigger>
        }
      </td>
      <td className='actions'>
        <EditButton to={`/plates/${item.id}`}/>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)}/>
      </td>
    </tr>
  }

  return (
    <div className="container">
      <PageTitle title='Retetele mele' buttons={<AddButton to='/plates/new'/>}/>
      <div className="row justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.plates} header={header} listItem={listItem}
                     searchFields={['name', 'category.name']}/>
        </div>
      </div>
    </div>
  )
};

export default PlatesList;